import {Box} from "@mantine/core";
import classes from "./SearchTextInput.module.css"
import {ChangeEvent, useContext} from "react";
import QRCodeContext from "../../../../contexts/qr-code/QRCodeContext";

/**
 * Search box.
 * It's using QRCodeContext and updates query.name
 * @since 0.1.7
 * @author Kacper Faber
 * @constructor
 */
function SearchTextInput() {
    /**
     * @author Kacper Faber
     * @since 0.1.7
     */
    const {query, setQuery} = useContext(QRCodeContext);

    /**
     * On input value changed.
     * @param ev
     * @author Kacper Faber
     * @since 0.1.7
     */
    const onTextChange = (ev: ChangeEvent<HTMLInputElement>) => {
        setQuery({ ...query, name: ev.target.value });
    }

    return (
        <Box p="md">
            <input
                type="text"
                onChange={onTextChange}
                className={classes.input}
                placeholder="Wyszukaj kody QR..."
            />
        </Box>
    );
}

export default SearchTextInput;

// TODO: SearchTextInput.tsx
//  Improve design